// HotX Console 0.1.109 游客页面原因模型。实际修改时间：2026-09-16 13:54:40 CST；精确父基线：cf5594169b784b215a2924abbfc0042baef03cbf。
export interface GuestPageAccess {
  message: string;
  authReason: string;
  reloadAfterLogin: boolean;
}

const CONFIG_PREVIEW_MESSAGE = '当前未登录；可以浏览并填写配置，保存或提交时会要求登录，当前内容不会丢失。';

const guestPageAccessByPath: Record<string, GuestPageAccess> = {
  '/dashboard': {
    message: '当前未登录；登录后可查看真实业务总览、服务状态和流量数据。',
    authReason: '登录后查看控制台业务总览',
    reloadAfterLogin: true
  },
  '/domains': {
    message: CONFIG_PREVIEW_MESSAGE,
    authReason: '登录后保存或提交域名配置',
    reloadAfterLogin: false
  },
  '/domains/new': {
    message: CONFIG_PREVIEW_MESSAGE,
    authReason: '登录后保存或提交域名配置',
    reloadAfterLogin: false
  },
  '/origins': {
    message: '当前未登录；登录后可读取现有域名和源站，并保存源站配置。',
    authReason: '登录后查看和管理源站',
    reloadAfterLogin: false
  },
  '/https': {
    message: '当前未登录；登录后可查看证书状态、申请证书并完成 DNS 验证。',
    authReason: '登录后查看和管理证书',
    reloadAfterLogin: false
  },
  '/cache': {
    message: '当前未登录；登录后可读取域名缓存规则并提交刷新或预热任务。',
    authReason: '登录后查看和管理缓存',
    reloadAfterLogin: false
  },
  '/traffic': {
    message: '当前未登录；登录后可查看账户域名的真实流量、请求和访问来源。',
    authReason: '登录后查看流量监控数据',
    reloadAfterLogin: true
  },
  '/ip-collections': {
    message: '当前未登录；登录后可查看已有 IP 集合并保存新的集合配置。',
    authReason: '登录后查看和管理 IP 集合',
    reloadAfterLogin: false
  },
  '/policies': {
    message: '当前未登录；登录后可读取已有策略并保存防护规则。',
    authReason: '登录后查看和管理策略',
    reloadAfterLogin: false
  },
  '/packages': {
    message: '当前未登录；登录后可查看实时套餐、积分余额和已购买分区。',
    authReason: '登录后查看套餐、积分余额并购买套餐',
    reloadAfterLogin: true
  },
  '/points': {
    message: '当前未登录；登录后可查看积分余额、签到记录、流水和消费订单。',
    authReason: '登录后查看积分中心',
    reloadAfterLogin: false
  },
  '/trx-recharge': {
    message: '当前未登录；登录后可查看 TRON 充值币种、创建订单和查询到账记录。',
    authReason: '登录后使用 TRON 充值',
    reloadAfterLogin: true
  },
  '/bsc-recharge': {
    message: '当前未登录；登录后可创建 BSC 充值订单并查看链上入账记录。',
    authReason: '登录后使用 BSC 充值',
    reloadAfterLogin: true
  },
  '/notifications': {
    message: '当前未登录；登录后可查看当前账户的消息和未读状态。',
    authReason: '登录后查看消息中心',
    reloadAfterLogin: true
  },
  '/security': {
    message: '当前未登录；登录后可查看域名防护数据并保存 CC 防护配置。',
    authReason: '登录后查看和管理安全防护',
    reloadAfterLogin: false
  },
  '/logs': {
    message: '当前未登录；登录后可查看访问、发布、操作和安全日志。',
    authReason: '登录后查看日志服务',
    reloadAfterLogin: true
  },
  '/account': {
    message: '当前未登录；登录后可查看账户资料、安全设置和服务状态。',
    authReason: '登录后查看账户中心',
    reloadAfterLogin: true
  }
};

export const GUEST_PAGE_PATHS = Object.freeze(Object.keys(guestPageAccessByPath));

const fallbackGuestPageAccess: GuestPageAccess = {
  message: '当前未登录；登录后可查看当前账户数据并继续操作。',
  authReason: '登录后继续使用客户控制台',
  reloadAfterLogin: false
};

export function guestPageAccessForPath(path: string): GuestPageAccess {
  const normalized = path.length > 1 ? path.replace(/\/+$/, '') : path;
  return guestPageAccessByPath[normalized] || fallbackGuestPageAccess;
}
